import { Actions, ActionTypes } from './actions';
import { Account } from '../../types/management-auth';
import { getItem } from '../../helpers/localStorage';

export interface State {
    account: Account | undefined;
    showWelcomeModal: boolean;
}

export const initialState: State = {
    account: undefined,
    showWelcomeModal: false,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.GetAccount:
            return {
                ...initialState,
                showWelcomeModal:
                    getItem(`welcome_modal_closed_${action.payload.accountId.substr(1)}`) !== 'true',
            };

        case ActionTypes.FetchAccountResponse:
            return {
                ...state,
                account: action.payload.account,
            };
        case ActionTypes.CloseModal:
            return {
                ...initialState,
                showWelcomeModal:
                    getItem(`welcome_modal_closed_${action.payload.accountId.substr(1)}`) !== 'true',
            };

        default:
            return state;
    }
}
